import { defineNuxtPlugin, watch } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import armsRum from '@arms/rum-browser';
import { UserService } from '@core/services/user.service';
import { getEnvString } from '@core/utils/environment';
import { version } from '../package.json';

const EXCEPTION_BLACKLIST = ['Canceled', 'Uncaught NetworkError'];
const RESOURCE_BLACKLIST = [
  'api/code-community-heart-beat/api/reward/authReward',
  'chrome-extension',
];

export default defineNuxtPlugin(() => {
  const userService = useRootService(UserService);
  const envString = getEnvString();
  const env =
    envString === 'production'
      ? 'prod'
      : envString === 'local'
        ? 'local'
        : 'daily';

  armsRum.init({
    endpoint:
      'https://proj-xtrace-a396f26b2598d0815d188971c02da759-cn-hangzhou.cn-hangzhou.log.aliyuncs.com/rum/web/v2?workspace=default-cms-1868493608389321-cn-hangzhou&service_id=iebq43cy4p@1f317032b73074fc68965',
    env,
    version,
    spaMode: 'history',
    collectors: {
      perf: true,
      webVitals: true,
      api: true,
      staticResource: true,
      jsError: true,
      consoleError: true,
      action: true,
    },
    tracing: false,
    filters: {
      resource: [
        (url: string) => RESOURCE_BLACKLIST.some((i) => url.includes(i)),
      ],
      exception: [
        /ResizeObserver.loop/,
        /^Script error\.?$/,
        (msg: string) => EXCEPTION_BLACKLIST.some((i) => msg.includes(i)),
      ],
    },
  });

  watch(
    () => userService.user?.userId,
    (userId) => {
      if (userId) {
        armsRum.setConfig('user', { name: String(userId) });
      }
    },
    { immediate: true },
  );
});
